import React, { Component, useState } from "react";
// import "./PerfEvalCEOFormEdit.css";
// import { Form,Button } from "react-bootstrap";
import { Form, Button, Col, Row } from "react-bootstrap";
import { MonthYearData } from "../../../shared/util/vars";
// import axios from "axios";

export default function PerfEvalEditCEOForm(props) {

  const [Monthyear, setMonthyear] = useState(props.editData["monthyear"]);
  const [Communication, setCommunication] = useState(
    props.editData["communication"]
  );
  const [Collaboration, setCollaboration] = useState(
    props.editData["collaboration"]
  );
  const [Problemsolving, setProblemsolving] = useState(
    props.editData["problemsolving"]
  );
  const [Quality, setQuality] = useState(props.editData["quality"]);
  const [Attendance, setAttendance] = useState(props.editData["attendance"]);
  const [Meetdeadline, setMeetdeadline] = useState(
    props.editData["meetdeadline"]
  );

  const HandleEdit = (type, e) => {
    if (type === "Monthyear") {
      setMonthyear(e);
    }
    if (e > 0 && e < 11) {
      if (type === "Communication") {
        setCommunication(e);
      } else if (type === "Collaboration") {
        setCollaboration(e);
      } else if (type === "Problemsolving") {
        setProblemsolving(e);
      } else if (type === "Quality") {
        setQuality(e);
      } else if (type === "Attendance") {
        setAttendance(e);
      } else if (type === "Meetdeadline") {
        setMeetdeadline(e);
      }
    }
  };
  const EditNow = (body, id) => {
    props.onPerfEvalCEOEditUpdate(body, id);
  };

  return (
    <div>
      <h2 id="role-form-title">Edit Performance Evaluation Marks</h2>

      <div id="role-form-outer-div">
        <Form id="form">
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Select Month & Year
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control
                as="select"
                required
                tabIndex={1}
                value={Monthyear}
                onChange={(e) => HandleEdit("Monthyear", e.target.value)}>
                <option value="" disabled selected>
                  Please select month and year
                </option>
                {MonthYearData.map((options, id) => (
                  <option key={id} value={options.value}>
                    {options.option}
                  </option>
                ))}
              </Form.Control>
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Communication Skills
            </Form.Label>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Communication", Number(Communication) - 1)
                }>
                -
              </Button>
            </Col>
            <Col sm={2} className="form-input">
              <Form.Control
                type="Number"
                required
                tabIndex={2}
                value={Communication}
                onChange={(e) => HandleEdit("Communication", e.target.value)}
              />
            </Col>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Communication", Number(Communication) + 1)
                }>
                +
              </Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Collaboration and Teamwork
            </Form.Label>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Collaboration", Number(Collaboration) - 1)
                }>
                -
              </Button>
            </Col>
            <Col sm={2} className="form-input">
              <Form.Control
                type="Number"
                required
                tabIndex={3}
                value={Collaboration}
                onChange={(e) => HandleEdit("Collaboration", e.target.value)}
              />
            </Col>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Collaboration", Number(Collaboration) + 1)
                }>
                +
              </Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Problem Solving
            </Form.Label>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Problemsolving", Number(Problemsolving) - 1)
                }>
                -
              </Button>
            </Col>
            <Col sm={2} className="form-input">
              <Form.Control
                type="Number"
                required
                tabIndex={4}
                value={Problemsolving}
                onChange={(e) => HandleEdit("Problemsolving", e.target.value)}
              />
            </Col>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Problemsolving", Number(Problemsolving) + 1)
                }>
                +
              </Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Quality and Accuracy of work
            </Form.Label>
            <Col sm={1} className="form-input">
              <Button
                onClick={() => HandleEdit("Quality", Number(Quality) - 1)}>
                -
              </Button>
            </Col>
            <Col sm={2} className="form-input">
              <Form.Control
                type="Number"
                required
                tabIndex={5}
                value={Quality}
                onChange={(e) => HandleEdit("Quality", e.target.value)}
              />
            </Col>
            <Col sm={1} className="form-input">
              <Button
                onClick={() => HandleEdit("Quality", Number(Quality) + 1)}>
                +
              </Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Attendance, punctuality and reliability
            </Form.Label>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Attendance", Number(Attendance) - 1)
                }>
                -
              </Button>
            </Col>
            <Col sm={2} className="form-input">
              <Form.Control
                type="Number"
                required
                tabIndex={6}
                value={Attendance}
                onChange={(e) => HandleEdit("Attendance", e.target.value)}
              />
            </Col>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Attendance", Number(Attendance) + 1)
                }>
                +
              </Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Accomplish Goals and Meet deadlines
            </Form.Label>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Meetdeadline", Number(Meetdeadline) - 1)
                }>
                -
              </Button>
            </Col>
            <Col sm={2} className="form-input">
              <Form.Control
                type="Number"
                required
                tabIndex={7}
                value={Meetdeadline}
                onChange={(e) => HandleEdit("Meetdeadline", e.target.value)}
              />
            </Col>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Meetdeadline", Number(Meetdeadline) + 1)
                }>
                +
              </Button>
            </Col>
          </Form.Group>

          <Form.Group as={Row} id="form-submit-button">
            <Col sm={{ span: 10, offset: 2 }}>
              <Button
                onClick={() =>
                  EditNow(
                    {
                      monthyear: String(Monthyear),
                      communication: String(Communication),
                      collaboration: String(Collaboration),
                      problemsolving: String(Problemsolving),
                      quality: String(Quality),
                      attendance: String(Attendance),
                      meetdeadline: String(Meetdeadline),
                    },
                    props.editData._id
                  )
                }>
                Update
              </Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row} id="form-cancel-button">
            <Col sm={{ span: 10, offset: 2 }} id="form-cancel-button-inner">
              <Button type="reset" onClick={props.onFormEditClose}>
                cancel
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
}
